import { render, staticRenderFns } from "./zmc10.vue?vue&type=template&id=97d2e82a"
import script from "./zmc10.vue?vue&type=script&lang=js"
export * from "./zmc10.vue?vue&type=script&lang=js"
import style0 from "./zmc10.vue?vue&type=style&index=0&id=97d2e82a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports